export const UPDATE_MENU_TITLE = {
  START: 'START_UPDATE_MENU_TITLE',
  COMPLETE: 'COMPLETE_UPDATE_MENU_TITLE',
  FAIL: 'FAIL_UPDATE_MENU_TITLE',
}

export const RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS = {
  START: 'START_RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS',
  COMPLETE: 'COMPLETE_RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS',
  FAIL: 'FAIL_RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS',
}

export const SET_MENU_TITLE_FOR_IGNORED_DISH_TYPE =
  'SET_MENU_TITLE_FOR_IGNORED_DISH_TYPE'

export const SET_MENU_TITLE_EXPANDED_ROW_KEYS =
  'SET_MENU_TITLE_EXPANDED_ROW_KEYS'

export const SET_MENU_TITLE_HIGHLIGHTED_ROW_KEY =
  'SET_MENU_TITLE_HIGHLIGHTED_ROW_KEY'

export const FETCH_MENU_TITLE_DISH_COUNTS = {
  START: 'START_FETCH_MENU_TITLE_DISH_COUNTS',
  COMPLETE: 'COMPLETE_FETCH_MENU_TITLE_DISH_COUNTS',
  FAIL: 'FAIL_FETCH_MENU_TITLE_DISH_COUNTS',
}
